import React, { useState, useEffect, useRef } from 'react';
import { callService } from "@Utils/ServiceUtils";
import { isEmpty, replace, langChangeMsg, getLanguage } from '@Views/utils/StringUtils';
import { Link, useHistory } from "react-router-dom"
import Slider from 'react-slick';
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import { Viewer } from '@toast-ui/react-editor';
import Popup from '@Views/comp/Popup';

const Main = ({ msg }: any) => {

    const history = useHistory();

    const sliderRef = useRef<any>();
    const [termList, setTermList] = useState<any>([]);
    let [dissScdList, setDissScdList] = useState<any>([]);
    let [ntcList, setNtcList] = useState<any>([]);
    let [nttList, setNttList] = useState<any>([]);

    let [mainStat1, setMainStat1] = useState<any>();
    let [mainStat2, setMainStat2] = useState<any>();
    let [mainStat3, setMainStat3] = useState<any>();
    let [mainStat4, setMainStat4] = useState<any>();
    let [mainStat5, setMainStat5] = useState<any>();

    let [selectedMainStat, setSelectedMainStat] = useState<any>({});

    let [mainIndicatorList, setMainIndicatorList] = useState<any>([]);

    let [popNtc, setPopNtc] = useState<any>();
    const popupRef: any = useRef();

    const [chart1Option, setChart1Option] = useState<any>({
        credits: {
            enabled: false
        },
        chart: {
            height: 170,
            margin: [50, 15, 2, 15],
            backgroundColor: 'rgba(225,225,225,0)',
            plotBorderWidth: 0,
            alignTicks: false
        },
        title: {
            text: null
        },
        xAxis: [{
            categories: [],
            visible: false,
        }],
        yAxis: [{
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                x: 7,
                y: -10,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,100,100)'
                }
            },
            labels: {
                x: 3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,100,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            stackLabels: {
                enabled: false
            },
            gridLineWidth: 0,
            tickInterval: 1,
        }, {
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                y: -10,
                x: -3,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                }
            },
            labels: {
                x: -3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            opposite: true,
            tickInterval: 3,
            gridLineWidth: 0
        }],
        legend: {
            enabled: true,
            x: 70,
            y: -100
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: 3
                },
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    },
                }
            },
            column: {
                states: {
                    hover: {
                        enabled: true,
                        color: '#cc0000',
                        borderColor: 'rgba(255,138,100,100)'
                    },
                }
            },
        },
        series: []
    });

    const [chart2Option, setChart2Option] = useState<any>({
        credits: {
            enabled: false
        },
        chart: {
            height: 170,
            margin: [50, 15, 2, 15],
            backgroundColor: 'rgba(225,225,225,0)',
            plotBorderWidth: 0,
            alignTicks: false
        },
        title: {
            text: null
        },
        xAxis: [{
            categories: [],
            visible: false,
        }],
        yAxis: [{
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                x: 7,
                y: -10,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                }
            },
            labels: {
                x: 3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            stackLabels: {
                enabled: false
            },
            gridLineWidth: 0,
            tickInterval: 1,
        }, {
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                y: -10,
                x: -3,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                }
            },
            labels: {
                x: -3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            opposite: true,
            tickInterval: 1,
            gridLineWidth: 0
        }],
        legend: {
            enabled: true,
            x: 70,
            y: -100
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: 3
                },
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    },
                }
            },
            column: {
                states: {
                    hover: {
                        enabled: true,
                        color: '#cc0000',
                        borderColor: 'rgba(255,138,100,100)'
                    },
                }
            },
        },
        series: []
    });

    const [chart3Option, setChart3Option] = useState<any>({
        credits: {
            enabled: false
        },
        chart: {
            height: 170,
            margin: [50, 15, 2, 15],
            backgroundColor: 'rgba(225,225,225,0)',
            plotBorderWidth: 0,
            alignTicks: false
        },
        title: {
            text: null
        },
        xAxis: [{
            categories: [],
            visible: false,
        }],
        yAxis: [{
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                x: 7,
                y: -10,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                }
            },
            labels: {
                x: 3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            stackLabels: {
                enabled: false
            },
            gridLineWidth: 0,
            tickInterval: 1,
        }, {
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                y: -10,
                x: -3,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                }
            },
            labels: {
                x: -3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            opposite: true,
            tickInterval: 5,
            gridLineWidth: 0
        }],
        legend: {
            enabled: true,
            x: 70,
            y: -100
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: 3
                },
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    },
                }
            },
            column: {
                states: {
                    hover: {
                        enabled: true,
                        color: '#cc0000',
                        borderColor: 'rgba(255,138,100,100)'
                    },
                }
            },
        },
        series: []
    });

    const [chart4Option, setChart4Option] = useState<any>({
        credits: {
            enabled: false
        },
        chart: {
            height: 170,
            margin: [50, 2, 2, 40],
            backgroundColor: 'rgba(225,225,225,0)',
            plotBorderWidth: 0,
            alignTicks: false
        },
        title: {
            text: null
        },
        xAxis: [{
            categories: [],
            visible: false,
        }],
        yAxis: [{
            title: {
                enabled: true,
                text: '',
                align: 'high',
                rotation: 0,
                offset: 0,
                y: -10,
                x: 0,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                }
            },
            labels: {
                x: -4,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            stackLabels: {
                enabled: false
            },
            gridLineWidth: 0
        }],
        legend: {
            enabled: false
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: false
                },
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    },
                }
            },
            column: {
                states: {
                    hover: {
                        enabled: true,
                        color: '#cc0000',
                        borderColor: 'rgba(255,138,100,100)'
                    },
                }
            },
        },
        series: []
    });

    const [chart5Option, setChart5Option] = useState<any>({
        credits: {
            enabled: false
        },
        chart: {
            height: 170,
            margin: [50, 15, 2, 15],
            backgroundColor: 'rgba(225,225,225,0)',
            plotBorderWidth: 0,
            alignTicks: false
        },
        title: {
            text: null
        },
        xAxis: [{
            categories: [],
            visible: false,
        }],
        yAxis: [{
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                x: 7,
                y: -10,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                }
            },
            labels: {
                x: 3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(255,138,110,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            stackLabels: {
                enabled: false
            },
            gridLineWidth: 0,
            tickInterval: 1,
        }, {
            title: {
                enabled: true,
                text: '(%)',
                align: 'high',
                rotation: 0,
                offset: 0,
                y: -10,
                x: -3,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                }
            },
            labels: {
                x: -3,
                y: 2,
                style: {
                    fontSize: '9px',
                    color: 'rgba(88,123,204,100)'
                },
                formatter: (el: any) => {
                    return Highcharts.numberFormat(el['value'], 0, '.', ',');
                }
            },
            opposite: true,
            tickInterval: 2,
            gridLineWidth: 0
        }],
        legend: {
            enabled: true,
            x: 70,
            y: -100
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: 3
                },
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    },
                }
            },
            column: {
                states: {
                    hover: {
                        enabled: true,
                        color: '#cc0000',
                        borderColor: 'rgba(255,138,100,100)'
                    },
                }
            },
        },
        series: []
    });

    let language = getLanguage();

    // 공표일정조회
    const OSUSE01R01 = async () => {

        let param = {
            langCd: language
        }

        const res = await callService("OSUSE01R01", param);

        if (res != null) {
            setDissScdList(res['dissScdList']);
        }

    }

    // 공지사항조회
    const OSMBA05R01 = async () => {

        const param = {
            pageNum: 1,
            langCd: language
        }

        const res = await callService("OSMBA05R01", param);

        if (res != null) {
            setNtcList(res['ntcList']);
        }

    }

    // 공지사항팝업조회
    const OSMBA01R03 = async () => {

        const param = {
            langCd: language.toUpperCase(),
            sysCd: '03',
            useYn: 'Y'
        }

        const res = await callService("OSMBA01R03", param);

        if (res != null) {

            if (isEmpty(res['ntcList']) === false) {

                setPopNtc(res['ntcList'][0]);

                const cookie: any = document.cookie;
                if (isEmpty(cookie) === false) {

                    let isPopNtcShow = true;

                    let cookieEach = cookie.split('; ');

                    cookieEach.forEach(function (each: string) {
                        let cookieName = each.split('=');
                        cookieName.forEach(function (name: string) {
                            if (name === 'isPopNtcShow') {
                                isPopNtcShow = false;
                            }
                        });
                    });

                    if (!isPopNtcShow) {
                        // 팝업 호출 X
                    }
                    else {
                        // 팝업 호출 O
                        popupRef['current'].isOpen(true);
                    }

                }
                else {
                    // 팝업 호출 O
                    popupRef['current'].isOpen(true);
                }

            }

        }

    }

    const OSUSE06R02 = async () => {
        const param = {
            mainSrwrYn: 'Y'
        }

        const res = await callService("OSUSE06R02", param);

        setTermList(res['sdSearchHistMList']);
    }

    // 메인통계5조회
    const OSUUA03R01 = async (dsId: String) => {

        const param = {
            dsId: dsId
        }

        const res = await callService("OSUUA03R01", param);

        for (const dataItem of res['dataDtlList']) {
            for (const key of Object.keys(dataItem)) {
                if (key !== 'timePeriod') {
                    dataItem[key] = parseFloat(dataItem[key]);
                }
            }

        }

        if (dsId === '200Y002') {
            setMainStat1(res);

            setSelectedMainStat(res);

            let indicators1 = {
                name: getLanguage() === 'ko' ? '전기대비' : 'QoQ',
                data: [],
                color: 'rgba(255,138,100,100)',
                type: 'column',
                yAxis: 0,
                zIndex: 1,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            let indicators2 = {
                name: getLanguage() === 'ko' ? '전년동기대비' : 'YoY',
                data: [],
                color: 'rgba(88,123,204,100)',
                type: 'line',
                yAxis: 1,
                zIndex: 4,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            chart1Option['xAxis'][0]['categories'] = [];
            let dataCvsnVal01: any = [];
            let dataCvsnVal02: any = [];

            let dtlCnt = res['dataDtlList'].length - 8;

            res['dataDtlList'].forEach(function (item: any, index: number) {
                if (index + 1 > dtlCnt) {
                    chart1Option['xAxis'][0]['categories'].push(getDataTime('Q', item['timePeriod']));
                    dataCvsnVal01.push(item['dataCvsnVal01']);
                    dataCvsnVal02.push(item['dataCvsnVal02']);
                }
            });

            indicators1['data'] = dataCvsnVal01;
            indicators2['data'] = dataCvsnVal02;
            chart1Option['series'] = [];
            chart1Option['series'].push(indicators1);
            chart1Option['series'].push(indicators2);

            setChart1Option({ ...chart1Option });
        }
        else if (dsId === '901Y009') {
            setMainStat2(res);

            let indicators1 = {
                name: getLanguage() === 'ko' ? '전월대비' : 'MoM',
                data: [],
                color: 'rgba(255,138,100,100)',
                type: 'column',
                yAxis: 0,
                zIndex: 1,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            let indicators2 = {
                name: getLanguage() === 'ko' ? '전년동월대비' : 'YoY',
                data: [],
                color: 'rgba(88,123,204,100)',
                type: 'line',
                yAxis: 1,
                zIndex: 4,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            chart2Option['xAxis'][0]['categories'] = [];
            let dataCvsnVal01: any = [];
            let dataCvsnVal02: any = [];

            let dtlCnt = res['dataDtlList'].length - 8;

            res['dataDtlList'].forEach(function (item: any, index: number) {
                if (index + 1 > dtlCnt) {
                    chart2Option['xAxis'][0]['categories'].push(getDataTime('M', item['timePeriod']));
                    dataCvsnVal01.push(item['dataCvsnVal01']);
                    dataCvsnVal02.push(item['dataCvsnVal02']);
                }
            });

            indicators1['data'] = dataCvsnVal01;
            indicators2['data'] = dataCvsnVal02;
            chart2Option['series'] = [];
            chart2Option['series'].push(indicators1);
            chart2Option['series'].push(indicators2);

            setChart2Option({ ...chart2Option });
        }
        else if (dsId === '404Y014') {
            setMainStat3(res);

            let indicators1 = {
                name: getLanguage() === 'ko' ? '전월대비' : 'MoM',
                data: [],
                color: 'rgba(255,138,100,100)',
                type: 'column',
                yAxis: 0,
                zIndex: 1,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            let indicators2 = {
                name: getLanguage() === 'ko' ? '전년동월대비' : 'YoY',
                data: [],
                color: 'rgba(88,123,204,100)',
                type: 'line',
                yAxis: 1,
                zIndex: 4,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            chart3Option['xAxis'][0]['categories'] = [];
            let dataCvsnVal01: any = [];
            let dataCvsnVal02: any = [];

            let dtlCnt = res['dataDtlList'].length - 8;

            res['dataDtlList'].forEach(function (item: any, index: number) {
                if (index + 1 > dtlCnt) {
                    chart3Option['xAxis'][0]['categories'].push(getDataTime('M', item['timePeriod']));
                    dataCvsnVal01.push(item['dataCvsnVal01']);
                    dataCvsnVal02.push(item['dataCvsnVal02']);
                }
            });

            indicators1['data'] = dataCvsnVal01;
            indicators2['data'] = dataCvsnVal02;
            chart3Option['series'] = [];
            chart3Option['series'].push(indicators1);
            chart3Option['series'].push(indicators2);

            setChart3Option({ ...chart3Option });
        }
        else if (dsId === '301Y013') {
            setMainStat4(res);

            let indicators1 = {
                name: '',
                data: [],
                color: 'rgba(255,138,100,100)',
                type: 'column',
                yAxis: 0,
                zIndex: 1,
                tooltip: {
                    valueSuffix: getLanguage() === 'ko' ? '억$' : '$Mill'
                },
            };

            chart4Option['xAxis'][0]['categories'] = [];
            let dataCvsnVal01: any = [];

            let dtlCnt = res['dataDtlList'].length - 8;

            res['dataDtlList'].forEach(function (item: any, index: number) {
                if (index + 1 > dtlCnt) {
                    chart4Option['xAxis'][0]['categories'].push(getDataTime('M', item['timePeriod']));
                    dataCvsnVal01.push(parseFloat(langChangeMsg(item['dataCvsnVal01'], (item['dataCvsnVal01'] * 100).toFixed(0))));
                }
            });

            indicators1['data'] = dataCvsnVal01;
            chart4Option['series'] = [];
            chart4Option['series'].push(indicators1);

            chart4Option['yAxis'][0]['title']['text'] = (getLanguage() === 'ko' ? '(억$)' : "($Mill)");

            setChart4Option({ ...chart4Option });
        }

        else if (dsId === '101Y004') {
            setMainStat5(res);

            let indicators1 = {
                name: getLanguage() === 'ko' ? '전월대비' : 'MoM',
                data: [],
                color: 'rgba(255,138,100,100)',
                type: 'column',
                yAxis: 0,
                zIndex: 1,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            let indicators2 = {
                name: getLanguage() === 'ko' ? '전년동월대비' : 'YoY',
                data: [],
                color: 'rgba(88,123,204,100)',
                type: 'line',
                yAxis: 1,
                zIndex: 4,
                tooltip: {
                    valueSuffix: '%'
                },
            };

            chart5Option['xAxis'][0]['categories'] = [];
            let dataCvsnVal01: any = [];
            let dataCvsnVal02: any = [];

            let dtlCnt = res['dataDtlList'].length - 8;

            res['dataDtlList'].forEach(function (item: any, index: number) {
                if (index + 1 > dtlCnt) {
                    chart5Option['xAxis'][0]['categories'].push(getDataTime('M', item['timePeriod']));
                    dataCvsnVal01.push(item['dataCvsnVal01']);
                    dataCvsnVal02.push(item['dataCvsnVal02']);
                }
            });

            indicators1['data'] = dataCvsnVal01;
            indicators2['data'] = dataCvsnVal02;
            chart5Option['series'] = [];
            chart5Option['series'].push(indicators1);
            chart5Option['series'].push(indicators2);

            setChart5Option({ ...chart5Option });
        }

    }

    // 메인일일지표조회
    const OSUUA03R02 = async () => {

        const param = {
            pageNum: 1,
            langCd: language
        }

        const res = await callService("OSUUA03R02", param);

        setMainIndicatorList(res['mainIndicatorList']);

    }

    // 보도자료조회
    const OSUSE99R01 = async () => {

        let url = null;

        if (getLanguage() === 'ko') {
            url = "bok.or.kr/portal/bbs/P0000559/boardEcos.json?menuNo=200690";
        } else {
            url = "bok.or.kr/eng/bbs/E0000634/boardEcosEng.json?menuNo=400069";
        }

        const param = {
            url: url
        }

        let res: any = await callService('OSUSE99R01', param);

        if (res['data'] !== 'ERROR') {
            res = JSON.parse(res['data']);
            setNttList(res['addJsonData']);
        }

    }

    const getDataTime = (baseFreq: string, key100statDataTime: string) => {
        let dataTime: string = '';

        let statDataTime = key100statDataTime;

        if (baseFreq === 'D') {
            dataTime += statDataTime.substr(0, 4) + "." + statDataTime.substr(4, 2) + "." + statDataTime.substr(6, 2);
        }
        else if (baseFreq === 'M') {
            dataTime += statDataTime.substr(0, 4) + "." + statDataTime.substr(4, 2);
        }
        else if (baseFreq === 'Q') {
            statDataTime = replace(statDataTime.substr(0, 4) + "." + statDataTime.substr(4, 2), "Q", "") + '/4';
            dataTime += statDataTime;
        }
        else if (baseFreq === 'A') {
            dataTime += statDataTime;
        }

        return dataTime;
    }

    const onclickMainStat5 = (dsId: string) => {

        let inptParmVal: any = {
            dsId: dsId,
            cdGrpList: []
        }

        if (dsId === '200Y002') {
            inptParmVal['cdGrpList'].push({ cdGrpId: 'G10487', cd: '10111' });
        }
        else if (dsId === '901Y009') {
            inptParmVal['cdGrpList'].push({ cdGrpId: 'G10957', cd: '0' });
        }
        else if (dsId === '404Y014') {
            inptParmVal['cdGrpList'].push({ cdGrpId: 'G10125', cd: '*AA' });
        }
        else if (dsId === '301Y013') {
            inptParmVal['cdGrpList'].push({ cdGrpId: 'G11473', cd: '000000' });
        }
        else if (dsId === '101Y004') {
            inptParmVal['cdGrpList'].push({ cdGrpId: 'G00074', cd: 'BBHA00' });
        }

        history.push({ pathname: '/SearchStat', state: inptParmVal });

    }

    const onClickPressReleaseSeeMore = () => {

        let url = null;
        if (getLanguage() === 'ko') {
            url = "https://www.bok.or.kr/portal/bbs/P0000559/list.do?menuNo=200690";
        } else {
            url = 'https://www.bok.or.kr/eng/bbs/E0000634/list.do?menuNo=400069';
        }

        window.open(url);

    }

    const quickLinkClick = (expandIndex: number) => {
        const expandDsList = ['0000000001', '0000000066', '0000000176', '0000000202', '0000000230', '0000000283', '0000000313', '0000000326', '0000000394']
        history.push({ pathname: '/SearchStat', state: { expandDsId: expandDsList[expandIndex] } });
    }

    const onMouseEnterMainStat = (e: any) => {

        let id = e['target']['id'];

        if (!isEmpty(id)) {

            if (id === 'mainStat1') {
                sliderRef['current'].slickGoTo(0);
            }
            else if (id === 'mainStat2') {
                sliderRef['current'].slickGoTo(1);
            }
            else if (id === 'mainStat3') {
                sliderRef['current'].slickGoTo(2);
            }
            else if (id === 'mainStat4') {
                sliderRef['current'].slickGoTo(3);
            }
            else if (id === 'mainStat5') {
                sliderRef['current'].slickGoTo(4);
            }

        }

    }

    const onClickNtt = (nttId: string) => {

        let url = null;
        if (getLanguage() === 'ko') {
            url = "https://www.bok.or.kr/portal/bbs/P0000559/view.do?menuNo=200690&nttId=" + nttId;
        } else {
            url = "https://www.bok.or.kr/eng/bbs/E0000634/view.do?menuNo=400069&nttId=" + nttId;
        }

        window.open(url);

    }

    const onChangeCheckboxPopNtcShow = () => {

        let todayDate = new Date();
        todayDate.setDate(todayDate.getDate() + 30);

        document.cookie = 'isPopNtcShow=false; path=/; expires=' + todayDate.toUTCString() + ';';
        popupRef['current'].isOpen(false);

    }

    const onClickSnapshot = () => {

        let url = null;
        if (window.location.href.indexOf('ecostest.bok.or.kr') === -1) {
            url = "http://snapshot.bok.or.kr/";
        } else {
            url = 'http://snapshottest.bok.or.kr/';
        }

        window.open(url);

    }

    useEffect(() => {
        OSUSE01R01();
        OSMBA05R01();
        OSMBA01R03();
        OSUSE99R01();
        OSUSE06R02();
        OSUUA03R01('200Y002'); // GDP
        OSUUA03R01('901Y009'); // 소비자물가
        OSUUA03R01('404Y014'); // 생산자물가 다시 변경
        OSUUA03R01('301Y013'); // 경상수지
        OSUUA03R01('101Y004'); // 통화량(M2)
    }, [language]);

    useEffect(() => {
        OSUSE01R01();
        OSMBA05R01();
        OSUSE99R01();
        OSUUA03R02(); // 메인일일지표조회
    }, []);


    return (
        <>
            {
                !isEmpty(popNtc) &&
                <Popup className="modal-sm" title={popNtc['ntcTtlNm']} ref={popupRef}>
                    <fieldset style={{ padding: '30px' }}>
                        {<Viewer initialValue={popNtc['ntcCtnt']} key={popNtc['ntcCtnt']} />}
                    </fieldset>
                    <div className="btn-wrap">
                        <div className="form-group form-group-checkbox">
                            <div className="input-box-group" style={{ float: 'right', padding: '10px' }}>
                                <div className="input-box">
                                    <div className="input-group">
                                        <input id="termsAgree" type="checkbox" className="form-control form-control-sm" onChange={onChangeCheckboxPopNtcShow} />
                                        <label htmlFor="termsAgree"><span>30일 동안 보지 않기</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            }

            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className={"main-wrap clearfix" + (getLanguage() === 'en' ? ' addEn' : '')}>
                    <div className="main-row1">
                        <div className={"main-search mainSearch_container" + (getLanguage() === 'en' ? ' addEn' : '')}>
                            <div className="searchTop">
                                <div className="mainSearchBox">
                                    <div className="form-group form-group-search">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <input className="main_searchInput" type="text" placeholder={msg['mainSearchPlaceholder']} onKeyDown={(e) => e.key === 'Enter' && history.push('/Search/' + encodeURIComponent(e.currentTarget.value))} />
                                            </div>
                                        </div>
                                        <div className="btn-search">
                                            <button type="button" className="btn"></button>
                                        </div>
                                    </div>
                                </div>

                                <div className="keySearch_terms">
                                    <div className="tit">{msg['keySerachTerms']}</div>
                                    <div className="keyBtnBox">
                                        {
                                            termList && termList.map((item: any, itemIndex: number) => (
                                                <button type="button" className="btn" onClick={(e) => history.push('/Search/' + encodeURIComponent(item['srwrNm']))} key={itemIndex}>#{item['srwrNm']}</button>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="quickMenu_list">
                                <ul className="quickList-box">
                                    {
                                        Array.from(Array(9), (e, i) =>
                                            <li className="quickList-item" key={i}>
                                                <a className="quickLink" tabIndex={0} onClick={() => quickLinkClick(i)} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { quickLinkClick(i) } }}>
                                                    <span className={"iconBox quick_icon0" + (i + 1)}></span>
                                                    <span style={{}} className="quickLink_txt">{msg['icon' + (i + 1)]}</span>
                                                </a>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="main-row2">
                        <div className="main-key-chart key_incoChart_container">
                            <div className={"keyChart-list" + (getLanguage() === 'en' ? ' addEn' : '')}>
                                <ul className="ChartList-inner">
                                    {
                                        mainStat1 !== undefined &&
                                        <li id="mainStat1" className="ChartList-box active" tabIndex={0} onClick={() => onclickMainStat5(mainStat1['dsId'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onclickMainStat5(mainStat1['dsId']) } }} onMouseEnter={(e: any) => { onMouseEnterMainStat(e) }}>
                                            <div className="listBox-wrap">
                                                <h2 className="listBox-tit">{langChangeMsg(mainStat1['dsNm'], mainStat1['dsEngNm'])}</h2>
                                                <div className="listBox-detail">
                                                    <span className="detail-grayTxt">{langChangeMsg(mainStat1['dataCvsnCdNm01'], mainStat1['dataCvsnCdEngNm01'])}</span>
                                                    <span className={"detail-num" + (mainStat1['dataCvsnVal01'] >= 0 ? '' : ' blueTxt')}>
                                                        <div>&nbsp;&nbsp;&nbsp;</div>
                                                        <span className="bigNum">{mainStat1['dataCvsnVal01'] == -0.0 ? '0.0' : mainStat1['dataCvsnVal01']}</span>
                                                        <span className="numUnit">{mainStat1['untNm01']}</span>
                                                    </span>
                                                    <div className="sub-detail">
                                                        <span className="grayTxt">{langChangeMsg(mainStat1['dataCvsnCdNm02'], mainStat1['dataCvsnCdEngNm02'])}</span>
                                                        <span className={"smallNum" + (mainStat1['dataCvsnVal02'] >= 0 ? '' : ' blue')}>{mainStat1['dataCvsnVal02'] == -0.0 ? '0.0' : mainStat1['dataCvsnVal02']}{mainStat1['untNm02']}</span>
                                                    </div>
                                                    <div className="detail-date">{getDataTime('Q', mainStat1['lastTimePeriod'])}</div>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                    {
                                        mainStat2 !== undefined &&
                                        <li id="mainStat2" className="ChartList-box" tabIndex={0} onClick={() => onclickMainStat5(mainStat2['dsId'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onclickMainStat5(mainStat2['dsId']) } }} onMouseEnter={(e: any) => { onMouseEnterMainStat(e) }}>
                                            <div className="listBox-wrap">
                                                <h2 className="listBox-tit">{langChangeMsg(mainStat2['dsNm'], mainStat2['dsEngNm'])}</h2>
                                                <div className="listBox-detail">
                                                    <span className="detail-grayTxt">{langChangeMsg(mainStat2['dataCvsnCdNm01'], mainStat2['dataCvsnCdEngNm01'])}</span>
                                                    <span className={"detail-num" + (mainStat2['dataCvsnVal01'] >= 0 ? '' : ' blueTxt')}>
                                                        <div>&nbsp;&nbsp;&nbsp;</div>
                                                        <span className="bigNum">{mainStat2['dataCvsnVal01'] == -0.0 ? '0.0' : mainStat2['dataCvsnVal01']}</span>
                                                        <span className="numUnit">{mainStat2['untNm01']}</span>
                                                    </span>
                                                    <div className="sub-detail">
                                                        <span className="grayTxt">{langChangeMsg(mainStat2['dataCvsnCdNm02'], mainStat2['dataCvsnCdEngNm02'])}</span>
                                                        <span className={"smallNum" + (mainStat2['dataCvsnVal02'] >= 0 ? '' : ' blue')}>{mainStat2['dataCvsnVal02'] == -0.0 ? '0.0' : mainStat2['dataCvsnVal02']}{mainStat2['untNm02']}</span>
                                                    </div>
                                                    <div className="detail-date">{getDataTime('M', mainStat2['lastTimePeriod'])}</div>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                    {
                                        mainStat3 !== undefined &&
                                        <li id="mainStat3" className="ChartList-box" tabIndex={0} onClick={() => onclickMainStat5(mainStat3['dsId'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onclickMainStat5(mainStat3['dsId']) } }} onMouseEnter={(e: any) => { onMouseEnterMainStat(e) }}>
                                            <div className="listBox-wrap">
                                                <h2 className="listBox-tit">{langChangeMsg(mainStat3['dsNm'], mainStat3['dsEngNm'])}</h2>
                                                <div className="listBox-detail">
                                                    <span className="detail-grayTxt">{langChangeMsg(mainStat3['dataCvsnCdNm01'], mainStat3['dataCvsnCdEngNm01'])}</span>
                                                    <span className={"detail-num" + (mainStat3['dataCvsnVal01'] >= 0 ? '' : ' blueTxt')}>
                                                        <div>&nbsp;&nbsp;&nbsp;</div>
                                                        <span className="bigNum">{mainStat3['dataCvsnVal01'] == -0.0 ? '0.0' : mainStat3['dataCvsnVal01']}</span>
                                                        <span className="numUnit">{mainStat3['untNm01']}</span>
                                                    </span>
                                                    <div className="sub-detail">
                                                        <span className="grayTxt">{langChangeMsg(mainStat3['dataCvsnCdNm02'], mainStat3['dataCvsnCdEngNm02'])}</span>
                                                        <span className={"smallNum" + (mainStat3['dataCvsnVal02'] >= 0 ? '' : ' blue')}>{mainStat3['dataCvsnVal02'] == -0.0 ? '0.0' : mainStat3['dataCvsnVal02']}{mainStat3['untNm02']}</span>
                                                    </div>
                                                    <div className="detail-date">{getDataTime('M', mainStat3['lastTimePeriod'])}</div>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                    {
                                        mainStat4 !== undefined &&
                                        <li id="mainStat4" className="ChartList-box" tabIndex={0} onClick={() => onclickMainStat5(mainStat4['dsId'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onclickMainStat5(mainStat4['dsId']) } }} onMouseEnter={(e: any) => { onMouseEnterMainStat(e) }}>
                                            <div className="listBox-wrap">
                                                <h2 className="listBox-tit">{langChangeMsg(mainStat4['dsNm'], mainStat4['dsEngNm'])}</h2>
                                                <div className="listBox-detail currentAccount-box">
                                                    <span className={"detail-num" + (mainStat4['dataCvsnVal01'] >= 0 ? '' : ' blueTxt')}>
                                                        <div>&nbsp;&nbsp;&nbsp;</div>
                                                        <span className="bigNum">{getLanguage() === 'ko' ? (mainStat4['dataCvsnVal01'] == -0.0 ? '0.0' : mainStat4['dataCvsnVal01']) : '$' + (mainStat4['dataCvsnVal01'] == -0.0 ? '0.0' : mainStat4['dataCvsnVal01'])}</span>
                                                        <span className="numUnit">{langChangeMsg(mainStat4['untNm01'], "Mill.")}</span>
                                                    </span>
                                                    <div className="detail-date">{getDataTime('M', mainStat4['lastTimePeriod'])}</div>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                    {
                                        mainStat5 !== undefined &&
                                        <li id="mainStat5" className="ChartList-box" tabIndex={0} onClick={() => onclickMainStat5(mainStat5['dsId'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onclickMainStat5(mainStat5['dsId']) } }} onMouseEnter={(e: any) => { onMouseEnterMainStat(e) }}>
                                            <div className="listBox-wrap">
                                                <h2 className="listBox-tit">{langChangeMsg(mainStat5['dsNm'], mainStat5['dsEngNm'])}</h2>
                                                <div className="listBox-detail">
                                                    <span className="detail-grayTxt">{langChangeMsg(mainStat5['dataCvsnCdNm01'], mainStat5['dataCvsnCdEngNm01'])}</span>
                                                    <span className={"detail-num" + (mainStat5['dataCvsnVal01'] >= 0 ? '' : ' blueTxt')}>
                                                        <div>&nbsp;&nbsp;&nbsp;</div>
                                                        <span className="bigNum">{mainStat5['dataCvsnVal01'] == -0.0 ? '0.0' : mainStat5['dataCvsnVal01']}</span>
                                                        <span className="numUnit">{mainStat5['untNm01']}</span>
                                                    </span>
                                                    <div className="sub-detail">
                                                        <span className="grayTxt">{langChangeMsg(mainStat5['dataCvsnCdNm02'], mainStat5['dataCvsnCdEngNm02'])}</span>
                                                        <span className={"smallNum" + (mainStat5['dataCvsnVal02'] >= 0 ? '' : ' blue')}>{mainStat5['dataCvsnVal02'] == -0.0 ? '0.0' : mainStat5['dataCvsnVal02']}{mainStat5['untNm02']}</span>
                                                    </div>
                                                    <div className="detail-date">{getDataTime('M', mainStat5['lastTimePeriod'])}</div>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                </ul>
                            </div>
                            <div className="keyChart_box">
                                {
                                    !isEmpty(selectedMainStat) &&
                                    <React.Fragment>
                                        <div className="keyChart_header">
                                            <div className="keyChart_tit">
                                                <div className="tit_main">{langChangeMsg(selectedMainStat['dsNm'], selectedMainStat['dsEngNm'])}</div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }
                                <Slider dots={false} infinite={true} slidesToShow={1} slidesToScroll={1} speed={100} pauseOnHover={false} arrows={false} beforeChange={(currentSlide, nextSlide) => {

                                    if (currentSlide !== nextSlide) {

                                        let index = nextSlide;

                                        if (index === 0) {
                                            setSelectedMainStat(mainStat1);
                                        }
                                        else if (index === 1) {
                                            setSelectedMainStat(mainStat2);
                                        }
                                        else if (index === 2) {
                                            setSelectedMainStat(mainStat3);
                                        }
                                        else if (index === 3) {
                                            setSelectedMainStat(mainStat4);
                                        }
                                        else if (index === 4) {
                                            setSelectedMainStat(mainStat5);
                                        }

                                        const eles: any = document.querySelectorAll('.ChartList-box');

                                        for (const ele of eles) {
                                            ele.classList.remove('active');
                                        }
                                        eles[index].classList.add('active');
                                    }

                                }} ref={sliderRef} >
                                    <div><HighchartsReact highcharts={Highcharts} options={chart1Option}></HighchartsReact></div>
                                    <div><HighchartsReact highcharts={Highcharts} options={chart2Option}></HighchartsReact></div>
                                    <div><HighchartsReact highcharts={Highcharts} options={chart3Option}></HighchartsReact></div>
                                    <div><HighchartsReact highcharts={Highcharts} options={chart4Option}></HighchartsReact></div>
                                    <div><HighchartsReact highcharts={Highcharts} options={chart5Option}></HighchartsReact></div>
                                </Slider>
                            </div>
                        </div>
                    </div>

                    {
                        language === 'ko' ?

                            <div className="main-sidemenu">
                                <ul className="sideMenu-inner">
                                    <li className="sideMenu-list list01">
                                        <a onClick={() => window.open('/api/')} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open('/api/') } }} tabIndex={0}>
                                            <span className="list-icon"></span>
                                            <span className="list-tit">Open API</span>
                                        </a>
                                    </li>
                                    <li className="sideMenu-list list02">
                                        <a onClick={() => window.open('https://dacos.bok.or.kr/')} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open('https://dacos.bok.or.kr/') } }} tabIndex={0}>
                                            <span className="list-icon"></span>
                                            <span className="list-tit" >DACOS</span>
                                        </a>
                                    </li>
                                    {language === 'ko' &&
                                        <li className="sideMenu-list list03">
                                            <a onClick={() => window.open('https://esurvey.bok.or.kr/')} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open('https://esurvey.bok.or.kr/') } }} tabIndex={0}>
                                                <span className="list-icon"></span>
                                                <span className="list-tit" >의향조사</span>
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                            : null
                    }

                    <div className="main-row3 clearfix">
                        <div className="main-left">
                            <div className="main-board clearfix">
                                <div className="board-wrap schedule">
                                    <div className="board board-hj">
                                        <div className="board-title">
                                            <h2>{msg['statisticalCalendar']}</h2>
                                        </div>
                                        <div className="board-content">
                                            <ul className="board-list">
                                                {
                                                    dissScdList.map((dissScd: any, dissScdIndex: number) => (
                                                        <React.Fragment key={dissScdIndex}>
                                                            {
                                                                dissScdIndex < 3 &&
                                                                <li className="board-list-item">
                                                                    <a className="board-link">
                                                                        <p className="item-title">{dissScd['dissObjStatNm']}</p>
                                                                        <div className="item-detail">
                                                                            <span className="detail-time">{dissScd['dissHhmi']}</span>
                                                                            <span className="detail-date">{dissScd['dissDd']}</span>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                        <div className="more">
                                            <Link onKeyUp={(e) => { if ((e['code'] === 'Space')) { history.push('/StatisticsSchedule') } }} to="/StatisticsSchedule"> {msg['seeMore']}</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="board-wrap news">
                                    <div className="board board-hj">
                                        <div className="board-title">
                                            <h2>{msg['pressRelease']}</h2>
                                        </div>
                                        <div className="more">
                                            <a onClick={onClickPressReleaseSeeMore} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onClickPressReleaseSeeMore() } }} tabIndex={0} >{msg['seeMore']}</a>
                                        </div>
                                        <div className="board-content">
                                            <ul className="board-list">
                                                {
                                                    nttList.map((ntt: any, nttIndex: number) => (
                                                        <React.Fragment key={nttIndex}>{
                                                            nttIndex < 3 &&
                                                            <li className="board-list-item">
                                                                <a tabIndex={0}
                                                                    onClick={() => { onClickNtt(ntt['nttId']) }}
                                                                    onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { onClickNtt(ntt['nttId']) } }}
                                                                    className="board-link">
                                                                    <p className="item-title">{ntt['nttSj']}</p>
                                                                    <div className="item-detail">
                                                                        <span className="detail-date">{ntt['registDt']}</span>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                        }</React.Fragment>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="main-notice">
                                <div className="notice-wrap notice-hj">
                                    <div className="notice-title">
                                        <h2>{msg['mainNotice']}</h2>
                                    </div>
                                    <div className="notice-content">
                                        <ul className="notice-list">
                                            {
                                                ntcList.map((ntc: any, ntcIndex: number) => (
                                                    <React.Fragment key={ntcIndex}>{
                                                        ntcIndex < 3 &&
                                                        <li className="notice-list-item">
                                                            <Link to={"/CustomerSupport/Notice/" + ntc['ntcId']} className="notice-link">
                                                                <p className="item-title">{ntc['ntcTtlNm']}</p>
                                                                <div className="item-detail">
                                                                    <span className="detail-date">{ntc['zRegDtm']}</span>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    }</React.Fragment>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                    <div className="more">
                                        <Link onKeyUp={(e) => { if ((e['code'] === 'Space')) { history.push('/CustomerSupport/Notice') } }} to="/CustomerSupport/Notice">{msg['seeMore']}</Link>
                                    </div>
                                </div>
                            </div>

                            <div className={"main-icon-menu" + (getLanguage() === 'en' ? ' addEn' : '')}>
                                <ul className="main-box clearfix">
                                    <li className="list-item list-item-left">
                                        <Link to="/StatisticsByTheme/KoreanStat100" onKeyUp={(e) => { if ((e['code'] === 'Space')) { history.push('/StatisticsByTheme/KoreanStat100') } }} >
                                            <span className="list-item-icon list-item01"></span>
                                            <span className="list-item-tit">{msg['koreanStat100']}</span>
                                        </Link>
                                    </li>
                                    {getLanguage() === 'ko' &&
                                        <>
                                            <li className="list-item list-item-right">
                                                <Link to="/StatisticsByTheme/RegionStat" onKeyUp={(e) => { if ((e['code'] === 'Space')) { history.push('/StatisticsByTheme/RegionStat') } }} >
                                                    <span className="list-item-icon list-item02"></span>
                                                    <span className="list-item-tit">{msg['regionStat']}</span>
                                                </Link>
                                            </li>
                                            <li className="list-item list-item-left">
                                                <a style={{ cursor: 'pointer' }} onClick={onClickSnapshot} >
                                                    <span className="list-item-icon list-item03"></span>
                                                    <span className="list-item-tit">금융·경제 스냅샷</span>
                                                </a>
                                            </li>
                                            <li className="list-item list-item-right">
                                                <Link to="/CustomerSupport/QNA" onKeyUp={(e) => { if ((e['code'] === 'Space')) { history.push('/CustomerSupport/QNA') } }} >
                                                    <span className="list-item-icon list-item04"></span>
                                                    <span className="list-item-tit">Q&amp;A</span>
                                                </Link>
                                            </li>
                                        </>
                                    }
                                </ul>
                            </div>
                        </div>

                        <div className="main-right">
                            <div className="main-indicators">
                                <div className="indicators-wrap indicators-hj">
                                    <h2 className="indi-title indi-title-01" style={{ marginBottom: '21px' }}>{msg['dailyIndicators']}</h2>
                                    <ul className="indi-list">
                                        <p style={{ marginTop: '5px', marginBottom: '5px' }}>{msg['dailyIndicatorsSub1']}</p>
                                        <li className="indi-list-item" style={{ paddingBottom: '10px', paddingTop: '5px' }}>
                                            <ul className="item-plus">
                                                {
                                                    mainIndicatorList.map((mainIndicator: any, mainIndicatorIndex: number) => (
                                                        <React.Fragment key={mainIndicatorIndex}>
                                                            {
                                                                mainIndicatorIndex < 3 &&
                                                                <li className="item-plus-item" style={{ marginBottom: '6px' }}>
                                                                    <div className="item-wrap">
                                                                        <div className="indi-value value-name">{langChangeMsg(mainIndicator['cdNm'], mainIndicator['cdEngNm'])}</div>
                                                                        <div className="indi-value value-current">{mainIndicator['obsValue']}</div>
                                                                        <div>
                                                                            <button style={{ textAlign: "right", paddingRight: "10px", cursor: "revert" }} type="button" tabIndex={-1} title={msg['precedingPeriodChange']} className={"btn indi-value value-color" + (Number(mainIndicator['difference']) === 0 ? ' default' : Number(mainIndicator['difference']) > 0 ? ' plus' : ' minus')}>{mainIndicator['difference'].replace('+', '')}</button>
                                                                        </div>
                                                                        <div className="indi-value value-date">
                                                                            {mainIndicator['timePeriod']}
                                                                            {mainIndicator['tradeTime'] ?
                                                                                mainIndicator['tradeTime'] === '88:88' ? ' ' + msg['timeClose'] :
                                                                                    mainIndicator['tradeTime'] === 'N1' ? ' 10:30' :
                                                                                        mainIndicator['tradeTime'] === 'N2' ? ' 11:30' :
                                                                                            mainIndicator['tradeTime'] === 'N3' ? ' 15:30' :
                                                                                                mainIndicator['tradeTime'] === 'N4' ? ' ' + msg['timeClose'] :
                                                                                                    (' ' + mainIndicator['tradeTime'])
                                                                                : ''
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </ul>
                                        </li>
                                        <p style={{ marginTop: '5px', marginBottom: '5px' }}>{msg['dailyIndicatorsSub2']}</p>
                                        <li className="indi-list-item" style={{ paddingBottom: '10px', paddingTop: '5px' }}>
                                            <ul className="item-plus">
                                                {
                                                    mainIndicatorList.map((mainIndicator: any, mainIndicatorIndex: number) => (
                                                        <React.Fragment key={mainIndicatorIndex}>
                                                            {
                                                                (mainIndicatorIndex >= 3 && mainIndicatorIndex < 6) &&
                                                                <li className="item-plus-item" style={{ marginBottom: '6px' }}>
                                                                    <div className="item-wrap">
                                                                        <div className="indi-value value-name">{langChangeMsg(mainIndicator['cdNm'], mainIndicator['cdEngNm'])}</div>
                                                                        <div className="indi-value value-current">{mainIndicator['obsValue']}</div>
                                                                        <div>
                                                                            <button style={{ textAlign: "right", paddingRight: "10px", cursor: "revert" }} type="button" tabIndex={-1} title={msg['precedingPeriodChange']} className={"btn indi-value value-color" + (Number(mainIndicator['difference']) === 0 ? ' default' : Number(mainIndicator['difference']) > 0 ? ' plus' : ' minus')}>{mainIndicator['difference'].replace('+', '')}</button>
                                                                        </div>
                                                                        <div className="indi-value value-date">
                                                                            {mainIndicator['timePeriod']}
                                                                            {mainIndicator['tradeTime'] ?
                                                                                mainIndicator['tradeTime'] === '88:88' ? ' ' + msg['timeClose'] :
                                                                                    mainIndicator['tradeTime'] === 'N2' ? ' 11:30' :
                                                                                        mainIndicator['tradeTime'] === 'N4' ? ' 16:00' :
                                                                                            (' ' + mainIndicator['tradeTime'])
                                                                                : ''
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </ul>
                                        </li>
                                        <p style={{ marginTop: '5px', marginBottom: '5px' }}>{msg['dailyIndicatorsSub3']}</p>
                                        <li className="indi-list-item" style={{ paddingBottom: '10px', paddingTop: '5px' }}>
                                            <ul className="item-plus">
                                                {
                                                    mainIndicatorList.map((mainIndicator: any, mainIndicatorIndex: number) => (
                                                        <React.Fragment key={mainIndicatorIndex}>
                                                            {
                                                                (mainIndicatorIndex >= 6 && mainIndicatorIndex < 8) &&
                                                                <li className="item-plus-item" style={{ marginBottom: '6px' }}>
                                                                    <div className="item-wrap">
                                                                        <div className="indi-value value-name">{langChangeMsg(mainIndicator['cdNm'], mainIndicator['cdEngNm'])}</div>
                                                                        <div className="indi-value value-current">{mainIndicator['obsValue']}</div>
                                                                        <div>
                                                                            <button style={{ textAlign: "right", paddingRight: "10px", cursor: "revert" }} type="button" tabIndex={-1} title={msg['precedingPeriodChange']} className={"btn indi-value value-color" + (Number(mainIndicator['difference']) === 0 ? ' default' : Number(mainIndicator['difference']) > 0 ? ' plus' : ' minus')}>{mainIndicator['difference'].replace('+', '')}</button>
                                                                        </div>
                                                                        <div className="indi-value value-date">{mainIndicator['timePeriod']}{mainIndicator['tradeTime'] ? (' ' + (mainIndicator['tradeTime'] === '88:88' ? msg['timeClose'] : mainIndicator['tradeTime'])) : ''}</div>
                                                                    </div>
                                                                </li>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
}
export default Main;